module.exports = __webpack_public_path__ + "411f84e17804396d75da70e19cad68f9.png";